import { tz } from '@date-fns/tz';

import { useProfile } from '#modules/user/features/profile/hooks/useProfile';
import { InTimeZone, TimeFormat } from '../types';
import { getTzFromNumber } from '../utils/getTzFromNumber';

export const useUserTimeSettings = (): {
  timeFormat: TimeFormat;
  timeZone?: InTimeZone;
  /** Тот же пояс строкой смещения (`+03:00`) — для `Intl`, который объект date-fns не понимает. */
  timeZoneName?: string;
} => {
  const { profile } = useProfile();

  if (profile) {
    /*
      Пояс — знаковые ЧАСЫ к востоку от UTC (Москва → 3), так пишет `signedTimeZoneOffsetHours`.
      Значение вне этого диапазона в профиле встречается: часть строк заведена скриптами и
      старыми клиентами в минутах, и `+180:00` — не пояс, а мусор. `Intl` на таком бросает
      RangeError, и метка времени в переписке роняла бы весь экран. Мусор просто игнорируем:
      время покажется по устройству, что честнее пустого экрана.
    */
    const offset = profile.timeZoneOffset;
    const isSaneOffset =
      offset !== null && offset !== undefined && !isNaN(offset) && offset >= -12 && offset <= 14;
    const zoneName = isSaneOffset ? getTzFromNumber(offset) : undefined;

    return {
      timeFormat: (profile?.timeFormat as TimeFormat) ?? 'TWENTY_FOUR',
      timeZone: zoneName ? tz(zoneName) : undefined,
      timeZoneName: zoneName,
    };
  }

  return {
    timeFormat: 'TWENTY_FOUR',
    timeZone: undefined,
    timeZoneName: undefined,
  };
};
